const homeLandingEN = {
	hero: {
		title:
			"Welcome to Sin Fila — bookings and digital scheduling in one place.",
		subtitle:
			"Visibility for businesses. Fast bookings for clients. Everything automated — no lines.",
		primaryCta: "I’m a business",
		secondaryCta: "Download App",
		platformText: "Available on iOS and Android.",
	},

	about: {
		title: "Who are we?",
		paragraph1:
			"We are Sin Fila, a Dominican platform where businesses and people connect to manage and book services quickly, easily, and without waiting in line.",
		paragraph2:
			"If you own a business, you organize your digital schedule, automate bookings, and increase your visibility so more people can find and book with you. As a client, you book in seconds, see available times, and avoid unnecessary waiting.",
		paragraph3:
			"One place to book, discover, and grow. All without lines.",
	},

	whatWeDo: {
		title: "What do we do?",
		description:
			"Sin Fila connects businesses with clients through simple, fast, no-wait digital bookings.",
	},

	business: {
		title: "For Businesses",
		intro:
			"Organize your schedule, automate appointments, and avoid losing clients.",
		items: [
			"Receive online bookings 24/7",
			"Automatic confirmations and reminders",
			"Clear schedules with no overlaps",
			"Public profile to attract new clients",
			"Less time on WhatsApp — more time working",
		],
		cta: "Go to business area",
	},

	clients: {
		title: "For Clients",
		intro:
			"Book your appointment in seconds, without calls or waiting.",
		items: [
			"See real availability",
			"Book instantly",
			"Receive automatic reminders",
			"Reschedule or cancel stress-free",
			"Find barbershops, salons, and more near you",
		],
		cta: "Explore businesses",
	},

	finalCta: {
		text: "Download on Google Play or App Store",
	},
};

export default homeLandingEN;
